export const WhatsappVerificationStep = {
  InputNumber: 0,
  InputOTP: 1,
  VerificationSuccess: 2,
  ConfirmWhatsappNumber: 3,
} as const;

export type WhatsappVerificationStep =
  (typeof WhatsappVerificationStep)[keyof typeof WhatsappVerificationStep];
